module.exports = __webpack_public_path__ + "img/btn-drop.73f6e926.svg";